import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  bodySectionContainer: {
    paddingHorizontal: 6,
  },
  headerStyle: theme => ({
    alignSelf: 'center',
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 20,
    color: theme.colors.rememberMeText,
    marginTop: 20,
  }),
  containerStyle: theme => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 10,
    elevation: 5,
    backgroundColor: theme.colors.backgroundColorFive,
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  }),
  overlayLottie: {
    height: 162,
    width: 162,
  },

  modalIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconContainer: {
    height: 125,
    width: 125,
  },
  message: theme => ({
    alignSelf: 'center',
    marginTop: 33,
    fontSize: Platform.OS === 'ios' ? 28 : 24.4,
    fontWeight: 'bold',
    color: theme.colors.rememberMeText,
    fontFamily: Fonts.type.VFFont,
    fontStyle: 'normal',
    lineHeight: 30,
    letterSpacing: 0,
  }),
  description: theme => ({
    textAlign: 'center',
    alignSelf: 'center',
    marginTop: 16,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    color: theme.colors.rememberMeText,
    lineHeight: 20,
  }),
  buttonsSectionContainer: {
    marginTop: 0,
  },
});
